import type { ReactNode } from "react";

/**
 * Only use this for English-only text in the admin UI. Otherwise, use Lingui's `<Trans>`.
 */
export function plural(number: number, singular: string, pluralForm: string): string;
export function plural(number: number, singular: ReactNode, pluralForm: ReactNode): ReactNode;
export function plural(number: number, singular: ReactNode, pluralForm: ReactNode): ReactNode {
    const form = number === 1 ? singular : pluralForm;

    if (typeof form === "string") {
        return `${number} ${form}`;
    }

    return (
        <>
            {number} {form}
        </>
    );
}
